const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_207",
  "data-name": "Group 207",
  transform: "translate(-1458 -243)"
}, /*#__PURE__*/React.createElement("g", {
  id: "question_1_",
  "data-name": "question (1)",
  transform: "translate(1458 242.997)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_345",
  "data-name": "Path 345",
  d: "M78,39A39,39,0,1,0,39,78,39,39,0,0,0,78,39Z",
  transform: "translate(0 0)",
  fill: "#f99d30"
})), /*#__PURE__*/React.createElement("g", {
  id: "question_2_",
  "data-name": "question (2)",
  transform: "translate(1384.016 265.718)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_193",
  "data-name": "Group 193",
  transform: "translate(100.984 0.72)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_192",
  "data-name": "Group 192"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_112",
  "data-name": "Ellipse 112",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(11.001 37.563)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_348",
  "data-name": "Path 348",
  d: "M123.86,12.341a12.438,12.438,0,0,0-24.876.1,1.584,1.584,0,0,0,3.169,0,9.269,9.269,0,1,1,18.538,0q0,.042,0,.084a9.264,9.264,0,0,1-5.634,8.45,8.648,8.648,0,0,0-5.222,7.989V32.64a1.584,1.584,0,1,0,3.169,0V28.961a5.484,5.484,0,0,1,3.3-5.074,12.429,12.429,0,0,0,7.559-11.449Q123.863,12.389,123.86,12.341Z",
  transform: "translate(-98.984 0)",
  fill: "#fff"
})))));
function SvgConfirmOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.001,
    height: 78,
    viewBox: "0 0 78.001 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmOrange);
export default __webpack_public_path__ + "static/media/confirm-orange.ae697864c7c639be25b747641d64049c.svg";
export { ForwardRef as ReactComponent };